import * as carriersActions from '../../../InsuranceForm/carriers';
import { insuranceTypeSelector } from '../insurance-type';

export function fetchCarriersIfNeeded(directoryId) {
    return (dispatch, getState) => {
        const state = getState();
        const insuranceType = insuranceTypeSelector(state);
        return carriersActions.fetchCarriersIfNeeded(insuranceType, directoryId)(dispatch, getState);
    };
}
